import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/sidebar/Sidebar';
import InfoBox from '../../components/InfoBox';
import LoadingFullscreen from '../../components/LoadingFullscreen';
import AddForm from '../../components/wali-kelas/AddForm';
import {
    storeWaliKelas,
    resetFormWaliKelas,
    showFormErrorWaliKelas,
    updateStateWaliKelas,
} from '../../features/waliKelasSlice';
import arrowLeft from '../../assets/icons/arrow-left.svg';
import '../../styles/css/add-karyawan.css';

function AddWaliKelas() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        selectedTeacher,
        selectedKelas,
        errors,
        loadingStore,
        statusResApi,
        messageResApi,
        isDisplayMessage,
    } = useSelector((state) => state.waliKelas);

    const [showAlert, setShowAlert] = useState(false);
    const isFormFilled = selectedTeacher !== null || selectedKelas !== null;
    const isFormValid = selectedTeacher?.id !== null && selectedTeacher !== null
        && selectedKelas?.id !== null && selectedKelas !== null;

    useEffect(() => {
        dispatch(resetFormWaliKelas());
    }, []);

    function handleBack() {
        if (isFormFilled) {
            setShowAlert(true);
        } else {
            navigate(-1);
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();
        dispatch(showFormErrorWaliKelas());
        if (!isFormValid) return;

        dispatch(storeWaliKelas({
            user_id: selectedTeacher.id,
            class_id: selectedKelas.id,
        })).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') {
                navigate(-1);
            }
        });
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='add-karyawan'>
                {isDisplayMessage && (
                    <InfoBox
                        message={messageResApi}
                        status={statusResApi}
                        isDisplay={isDisplayMessage}
                        setIsDisplay={updateStateWaliKelas}
                        stateName='isDisplayMessage'
                    />
                )}
                <div className='navigation'>
                    <div>
                        <div className='wrapper-img' onClick={handleBack}>
                            <img src={arrowLeft} alt="" />
                        </div>
                        <h1>Tambah Wali Kelas</h1>
                    </div>
                    <button onClick={handleSubmit} className='btn-submit'>
                        Konfirmasi
                    </button>
                </div>
                <div className='form-foto-profile'>
                    <AddForm />
                </div>

                {showAlert && (
                    <div className='bg-modal'>
                        <div className='alert-modal'>
                            <h1>Tambah Wali Kelas</h1>
                            <p>Kamu yakin keluar halaman? Form akan terhapus.</p>
                            <div>
                                <button onClick={() => setShowAlert(false)}>Tidak</button>
                                <button onClick={() => navigate(-1)}>Iya</button>
                            </div>
                        </div>
                    </div>
                )}

                <LoadingFullscreen loading={loadingStore} />
            </div>
        </div>
    );
}

export default AddWaliKelas;
